// extracted by mini-css-extract-plugin
export default {"versionInfoContainer":"version-info_versionInfoContainer__gp2y4","versionInfo":"version-info_versionInfo__lHwbX"};